import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faCodepen, faHackerrank, faDribbble, faYoutube } from '@fortawesome/free-brands-svg-icons';
export default function Footer() {


    const socials = [
        { icon: faGithub, link: 'https://github.com/van-surya' },
        { icon: faCodepen, link: 'https://codepen.io/dawnscript' },
        { icon: faHackerrank, link: 'https://www.hackerrank.com/profile/van_surya' },
        { icon: faDribbble, link: 'https://dribbble.com/van_surya' },
        { icon: faYoutube, link: 'https://www.youtube.com/@dawnscript?si=n8Qqt9lp8h8m23d_' },
    ];

    return (

        <footer className="w-full pb-4 lg:pb-3 bg-smoke mt-auto">
            <div className="container mx-auto px-4 md:px-8 py-8 md:pt-24 md:pb-12 lg:py-8">
                <div className="flex flex-col items-center lg:flex-row lg:justify-between">
                    <div className="border border-lemone w-fit p-2">
                        <p className='font-jedira text-6xl md:text-8xl text-lemone'>Let’s Talk.</p>
                        <p className='font-jedira text-lemone text-2xl md:text-3xl'>
                            Work with us </p>
                    </div>
                    <div className="mt-auto md:mt-8 lg:mt-0">
                        <div className="flex flex-row justify-center lg:justify-end py-4 md:pb-2 lg:py-0">
                            {socials.map((social, x) => (
                                <motion.div className='' key={x}

                                >
                                    <a href={social.link} className="w-[42px] h-[42px] rounded-md flex items-center justify-center text-[1.7rem] text-lemone hover:bg-lemone hover:text-smoke "
                                    >
                                        <FontAwesomeIcon icon={social.icon} />
                                    </a>
                                </motion.div>
                            ))}
                        </div>
                        <p className='text-base md:text-2xl text-lemone text-center'>©2024 <span className='text-smoke bg-lemone'>Surya</span>. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
